import { render, staticRenderFns } from "./AddSmsTemplate.vue?vue&type=template&id=38e8a682&scoped=true"
import script from "./AddSmsTemplate.vue?vue&type=script&lang=js"
export * from "./AddSmsTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddSmsTemplate.vue?vue&type=style&index=0&id=38e8a682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8a682",
  null
  
)

export default component.exports